<template>
  <div class="home-main">
    <div class="header">
      <img
        style="height:132px; width: 1170px"
        class="img-fluid home-img"
        src="/covid19/img/banner.jpg"
        alt="home-img"
      />
    </div>
    <div style="flex-direction:column;" class="home-content flex-centered">
      <div  style="margin-top:0; align-items: flex-start;width: 100%;
    display: flex;
    justify-content: space-evenly;
}" class="conteudos-menu flex-centered">
      <!--  <div @click="$router.push({ name: 'Menu', params: {select:'materias'} })" style="flex-direction:column" class="conteudo-menu flex-centered">
          <div class="icons flex-centered">
            <i style="color:#D2FAE6;" class="fas fa-circle elipse-menu"></i>
            <i style="position:absolute; font-size: 30px;" class="far fa-file-alt"></i>
          </div>
          <p>Matérias</p>
          <div style="background:#D2FAE6" class="bottombar"></div>
        </div>
        <div @click="$router.push({ name: 'Menu', params: {select:'plantoes'} })" style="flex-direction:column" class="conteudo-menu flex-centered">
          <div class="icons flex-centered">
            <i style="color:#C1EBF6" class="fas fa-circle elipse-menu"></i>
            <i style="position:absolute; font-size: 30px;" class="far fa-bookmark"></i>
          </div>
          <p>Plantões</p>
          <div style="background:#C1EBF6" class="bottombar"></div>
        </div>
        <div @click="$router.push({ name: 'Menu', params: {select:'perguntaserespostas'} })" style="flex-direction:column;" class="conteudo-menu flex-centered">
          <div class="icons flex-centered">
            <i style="color:#D6D5FE" class="fas fa-circle elipse-menu"></i>
            <i style="position:absolute; font-size: 30px;" class="far fa-question-circle"></i>
          </div>
          <p style="font-size: 20px;position: relative;top: -14px;">
            Perguntas
            <br />e Respostas
          </p>
          <div :class="{}" style="background:#D6D5FE" class="bottombar"></div>
        </div>
        <div @click="$router.push({ name: 'Menu', params: {select:'videos'} })" style="flex-direction:column" class="conteudo-menu flex-centered">
          <div class="icons flex-centered">
            <i style="color:#FDDBCD;" class="fas fa-circle elipse-menu"></i>
            <i style="position:absolute; font-size: 30px;" class="far fa-file-video"></i>
          </div>
          <p>Vídeos</p>
          <div style="background:#FDDBCD" class="bottombar"></div>
        </div>-->
        <div @click="$router.push({ name: 'Menu', params: {select:'legislacoes'} })" style="flex-direction:column" class="conteudo-menu flex-centered">
          <div class="icons flex-centered">
            <i style="color:#FDF48E" class="fas fa-circle elipse-menu"></i>
            <i style="position:absolute; font-size: 30px;" class="fas fa-book"></i>
          </div>
          <p>Legislações</p>
          <div style="background:#FDF48E" class="bottombar"></div>
        </div>
        <div @click="$router.push({ name: 'Menu', params: {select:'links'} })" style="flex-direction:column;" class="conteudo-menu flex-centered">
          <div class="icons flex-centered">
            <i style="color:#FED5EF" class="fas fa-circle elipse-menu"></i>
            <i style="position:absolute; font-size: 30px;" class="fas fa-link"></i>
          </div>
          <p>
            Links
          </p>
          <div style="background:#FED5EF" class="bottombar"></div>
        </div>
      </div>
    </div>
    <div class="view">
          <visual :view="$route.params.select" />
        </div>
  </div>
</template>

<script>
import visual from '../component/Menu/Visual'
export default {
    data(){
        return{
        }
    },
    components: { visual },
    methods:{   
    },
    mounted(){
       
    },
    computed:{
       
    }
}
</script>

<style>
.flex-centered {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 50px 0 20px 0;
}

.bordert {
  border-bottom: 1px solid rgb(0, 0, 0, 0.35);
  margin: 80px 0;
}

.header {
  display: flex;
  justify-content: center;
  align-items: center;
}

.home-img {
  z-index: 1;
  position: relative;
  object-fit: cover;
}

.home-title {
  position: absolute;
  font-size: 50px;
  top: 305px;
  left: 510px;
  z-index: 2;
  color: #ffffff;
}

.home-content {
  background: white;
  position: relative;
  top: -100px;
  align-self: center;
  z-index: 3;
  border-radius: 10px;
  box-shadow: 10px 10px 56px #4e5e6d1a;
  margin: 20px 90px 0 90px;
}

.home-content p {
  margin-top: 50px;
  color: #383838;
  font-size: 30px;
  font-weight: 700;
}

.dica {
  margin: 30px !important;
}

.dica p {
  font-size: 15px;
  font-weight: 600;
  text-align: center;
}

.conteudo-menu {
  margin: 0 30px;
  cursor: pointer;
}

.conteudo-menu p {
  font-size: 25px;
  color: #383838;
  font-style: italic;
  text-align: center;
  width:100%;
  line-height: 30px;
  font-weight: 500;
  margin:0;
}

.bottombar {
  position: absolute;
  width: 150px;
  height: 0;
  bottom: 0;
}

.conteudo-menu:hover .bottombar {
  width: 150px;
  height: 10px;
}

.elipse-menu {
  font-size: 70px;
}

.abrir-btn {
  width: 141px;
  height: 40px;
  background: #444e67;
  border-radius: 5px;
  color: #ffffff;
  font-style: italic;
  font-weight: lighter;
  font-size: 20px;
}
</style>